import { PureComponent } from "react";
import classnames from "classnames";
import colors from "styles/colors";
import RightArrow from "/static/svg/arrow-right-3.svg";
import componentStyles from "./button-component.scss";
import {
  generateOnKeyDownHandler,
  getAccessibleButtonColor
} from "client/services/accessibility/accessibility-service";

// BUTTON SIZES
export const XS = "xs";
export const SM = "sm";
export const MD = "md";
export const LG = "lg";
export const FULL = "full";

// BUTTON COLORS
export const BLUE = "blue";
export const MINT_GREEN = "mint-green";
export const BOLD_BLUE = "bold-blue";
export const WHITE = "white";
export const IRIS = "iris";

export default class ButtonComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.onKeyDown = generateOnKeyDownHandler(this.onClick);
  }

  getComponentInlineStyles() {
    const { textColor } = this.props;

    return {
      color: textColor
    };
  }

  onClick = (e) => {
    const { onClick, disabled } = this.props;
    e?.target.blur(); //remove focus on mouse click

    if (disabled) return;
    onClick(e);
  };

  render() {
    const { children, className, color, size, outline, disabled, isWithArrow } = this.props;
    const inlineComponentStyles = this.getComponentInlineStyles();

    const accessibleColor = getAccessibleButtonColor(color);

    return (
      <div
        className={classnames("button-component", className, size, accessibleColor, { outline, disabled })}
        onClick={this.onClick}
        style={inlineComponentStyles}
        onKeyDown={this.onKeyDown}
        tabIndex={disabled ? -1 : 0}
        role={"button"}
      >
        {children}
        {isWithArrow && (
          <span className="arrow-wrapper">
            <RightArrow />
          </span>
        )}
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

ButtonComponent.defaultProps = {
  className: "",
  color: BLUE,
  size: MD,
  outline: false,
  textColor: colors["white"],
  disabled: false
};
